import { useState } from "react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin({ title = "Admin", onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!email || !password) {
      toast.error("Enter your email and password.");
      return;
    }
    setBusy(true);
    try {
      const r = await fetch(`${API}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Login failed");
      const cred = `Bearer ${data.token}`;
      localStorage.setItem("vsl_admin_key", cred);
      onSuccess(cred);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0a0a0a] px-6 font-sans text-white" data-testid="admin-login">
      <div className="w-full max-w-sm border border-white/10 bg-black/40 p-10">
        <p className="text-[10px] font-semibold uppercase tracking-[0.35em] text-neutral-500">Sergio Chavez</p>
        <h1 className="mt-4 font-serif text-2xl font-light">{title}</h1>
        <div className="mt-6">
          <label className="mb-2 block text-[10px] font-semibold uppercase tracking-[0.3em] text-neutral-500" htmlFor="admin_email">Email</label>
          <input
            id="admin_email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@email.com"
            className="w-full border border-white/10 bg-white/5 px-4 py-3.5 text-sm text-white outline-none focus:border-white/40"
            data-testid="admin-login-email"
          />
        </div>
        <div className="mt-4">
          <label className="mb-2 block text-[10px] font-semibold uppercase tracking-[0.3em] text-neutral-500" htmlFor="admin_password">Password</label>
          <input
            id="admin_password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
            placeholder="••••••••"
            className="w-full border border-white/10 bg-white/5 px-4 py-3.5 text-sm text-white outline-none focus:border-white/40"
            data-testid="admin-login-password"
          />
        </div>
        <button
          onClick={submit}
          disabled={busy}
          className="mt-6 w-full bg-white px-8 py-3.5 text-xs font-semibold uppercase tracking-[0.25em] text-black transition-colors hover:bg-neutral-300 disabled:opacity-50"
          data-testid="admin-login-submit"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </div>
    </div>
  );
}
